import { Component, output, signal } from '@angular/core';
import { DsButtonModule, DsModalModule } from '@bmw-ds/components';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'pure-data-privacy-disclaimers-modal',
  imports: [DsModalModule, TranslateModule, DsButtonModule],
  templateUrl: './data-privacy-disclaimers-modal.component.html',
  styleUrl: './data-privacy-disclaimers-modal.component.scss',
})
export class DataPrivacyDisclaimersModalComponent {
  modalIsOpen = signal<boolean>(true);
  closed = output<void>();

  modalDismissed(): void {
    this.modalIsOpen.set(false);
    this.closed.emit();
  }
}
